import {
  GET_GOLF_BOOKING,
  GET_GOLF_BOOKING_SUCCESS,
  GET_GOLF_BOOKING_ERROR,
} from "./../../actionType.js";

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GolfBookings = (state = initialState, action) => {
  switch (action.type) {
    case GET_GOLF_BOOKING:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_BOOKING_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GOLF_BOOKING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GolfBookings;
